module.exports = __webpack_public_path__ + "img/bw.9a7528b9.svg";